import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setToken, setTokens, TENANT_SLUG } from "../auth";
import api from "../api";

// Reuses the existing BPM login: posts credentials to REACT_APP_AUTH_URL and
// reads the JWT from REACT_APP_AUTH_TOKEN_PATH. Also supports pasting a token
// (e.g. copied from the main portal) for SSO-style access.
const AUTH_URL = process.env.REACT_APP_AUTH_URL;
const TOKEN_PATH = process.env.REACT_APP_AUTH_TOKEN_PATH || "data.accessToken";
const REFRESH_PATH = process.env.REACT_APP_AUTH_REFRESH_PATH || "data.refresh_token";

const dig = (obj, path) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);

export default function Login() {
  const navigate = useNavigate();
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [paste, setPaste] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      // Only the pre-tenant 'default' tenant still signs in through the main BPM portal.
      const viaBpm = AUTH_URL && TENANT_SLUG === "default";
      const res = viaBpm
        ? await axios.post(AUTH_URL, { username, password, email: username })
        : await api.post("/auth/login", { tenant: TENANT_SLUG, username, password });
      const token = viaBpm
        ? dig(res.data, TOKEN_PATH) || res.data?.token || res.data?.accessToken
        : res.data?.data?.access_token;
      if (!token) throw new Error("No token in login response");
      // Keep the refresh token too — api.js uses it to renew the short-lived
      // access token instead of bouncing the user back here every 15 minutes.
      const refresh = viaBpm ? dig(res.data, REFRESH_PATH) || res.data?.refresh_token : null;
      setTokens(token, refresh); navigate("/");
    } catch (e2) {
      setErr(e2?.response?.data?.message || e2.message || "Login failed");
    }
    setBusy(false);
  };

  const usePaste = () => { if (paste.trim()) { setToken(paste.trim()); navigate("/"); } };

  return (
    <div className="login">
      <div className="box">
        <h2>Vnixa DPDP</h2>
        <p>Compliance Management System{TENANT_SLUG ? ` · ${TENANT_SLUG}` : ""}</p>
        <form onSubmit={login}>
          <div className="form-row"><label>Username / Email</label><input value={username} onChange={(e) => setU(e.target.value)} autoFocus /></div>
          <div className="form-row"><label>Password</label><input type="password" value={password} onChange={(e) => setP(e.target.value)} /></div>
          <button className="btn primary" style={{ width: "100%" }} disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        {err && <div className="err">{err}</div>}
        <details style={{ marginTop: 16 }}>
          <summary style={{ cursor: "pointer", color: "#64748b", fontSize: 12 }}>Sign in with an existing token</summary>
          <div className="form-row" style={{ marginTop: 8 }}><textarea placeholder="Paste JWT…" value={paste} onChange={(e) => setPaste(e.target.value)} /></div>
          <button type="button" className="btn" onClick={usePaste}>Use token</button>
        </details>
      </div>
    </div>
  );
}
